import { styled } from '@mui/material/styles';
import { Box, Paper, Typography, Link, IconButton } from '@mui/material';

export const RootBox = styled(Box)(({ theme }) => ({
  height: 'calc(100vh - 125px)',
  padding: theme.spacing(2),
  paddingTop: theme.spacing(5),
  overflowY: 'auto',
  width: '100%',
  maxWidth: '100%',
  boxSizing: 'border-box',
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  minWidth: 0,
}));

export const SectionBox = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(3),
}));

export const TitleTypography = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

export const ToolItemDiv = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
});

export const StudentHeaderPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  marginBottom: theme.spacing(2),
  backgroundColor: theme.palette.primary.light,
  color: theme.palette.primary.contrastText,
  borderRadius: theme.shape.borderRadius,
}));

export const StudentNameTypography = styled(Typography)({
  fontWeight: 'bold',
});

export const StudentInfoTypography = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(1),
  fontSize: '0.9rem',
}));

export const TableContainerBox = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(2),
}));

export const TableHeaderBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.grey[100],
  fontWeight: 'bold',
}));

export const GbLink = styled(Link)({
  fontWeight: '600',
});

export const CloseButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  top: theme.spacing(1),
  right: theme.spacing(1),
  zIndex: 1000,
}));

export const closeIconStyles = (theme) => ({
  fill: theme.palette.grey[700],
});
